import React from "react";
import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";

interface AzureViewPageProps extends NSARouterMakerResult, CredentialProps { }

class AzureViewPage extends React.Component<AzureViewPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section shows the full details of a Microsoft Azure credential, including its name, client id, tenant id, and the client secret it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
				}}
				pages={{
					entity: CredentialEntities.azure(this.props),
					view: {}
				}}
			>
				<></>
			</CredentialLayout>
		);
	}
}

export default AzureViewPage;